import { render, staticRenderFns } from "./balanceDetail.vue?vue&type=template&id=47aeb8ee&scoped=true&"
import script from "./balanceDetail.vue?vue&type=script&lang=js&"
export * from "./balanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./balanceDetail.vue?vue&type=style&index=0&id=47aeb8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aeb8ee",
  null
  
)

export default component.exports